<template>
  <li v-if="message && visible && message.notif" class="self">
    <div class="containerMessage">
      <div class="msg" style="background-color: #e8e7e7; font-style: italic">
        <div
          :style="{
            color: invertColor(getWebchat().campaign.color),
          }"
          class="black-text"
        >
          <v-icon>mdi-alert-circle-outline</v-icon> {{ message.message }}
        </div>
      </div>
    </div>
  </li>

  <li
    v-else-if="visible && message && menuMessage(message.message)"
    :class="{ self: message && message.self, other: message && !message.self }"
  >
    <messageMenu ref="menuMessage" :message="message"></messageMenu>
  </li>

  <li
    v-else-if="message && surveyMessage(message.message)"
    :class="{
      self: message && message.self,
      'other otherSurvey': message && !message.self,
    }"
  >
    <messageSurvey
      v-if="isFaces(message.message)"
      ref="surveyMessage"
      :message="message"
    ></messageSurvey>
    <messageSurveyYesNo
      v-else-if="isYesNo(message.message)"
      :message="message"
    ></messageSurveyYesNo>
  </li>

  <li
    v-else-if="visible"
    :class="{ self: message && message.self, other: message && !message.self }"
  >
    <v-row class="containerMessage" no-gutters>
      <v-col
        cols="12"
        class="d-flex"
        :class="{
          self: message && message.self,
          other: message && !message.self,
        }"
      >
        <img
          v-if="
            message &&
            !message.self &&
            getWebchat().campaign.show_agent_image_aside
          "
          :src="avatar"
          :alt="
            getWebchat().campaign.logo
              ? getWebchat().campaign.logoName
              : getWebchat().campaign.name
          "
          :title="getWebchat().campaign.name"
          class="logo mr-2"
          style="aspect-ratio: 1/1; width: 40px; border-radius: 100%"
        />
        <div
          class="msg"
          :style="{
            'background-color':
              message && !message.self
                ? getWebchat().campaign.color
                : '#e8e7e7'
          }"
        >
          <div v-if="message.message">
            <div
              v-linkify
              v-for="(item, index) in getEnters(message.message)"
              :message="item"
              :key="index"
              :style="{
                color: invertColor(getWebchat().campaign.color),
                'font-family':
                  OS === `Windows`
                    ? `'Open Sans','Noto Color Emoji'`
                    : `'Open Sans', sans-serif !important;`,
              }"
              :class="{ 'black-text': message && message.self }"
              v-html="styleMessage(item)"
            >
              {{ item }}
            </div>
          </div>

          <attachments
            v-if="message.attachments && message.attachments.length"
            :files="message.attachments"
            :messageColor="message && !message.self
                ? getWebchat().campaign.color
                : '#e8e7e7'"
          ></attachments>
        </div>
      </v-col>
      <v-col
        cols="12"
        class="d-flex"
        :class="{
          self: message && message.self,
          other: message && !message.self,
        }"
      >
        <p>{{ message.date }}</p>
      </v-col>
    </v-row>
  </li>
</template>

<script>
import { mapGetters } from "vuex";
import Attachments from "./attachments";
import { invertColor } from "@/assets/utils";
import MessageMenu from "./messageMenu";
import MessageSurvey from "./messageSurvey";
import MessageSurveyYesNo from "./messageSurveyYesNo";
import linkify from "vue-linkify";
import { styleMessage } from "@/assets/utils";
import Avatar from "../assets/avatar.png";

export default {
  props: { message: Object, visible: Boolean },
  components: { Attachments, MessageMenu, MessageSurvey, MessageSurveyYesNo },
  name: "message",

  data() {
    return {
      window: window,
      OS: navigator.platform === "Win32" ? "Windows" : "Other",
      avatar:
        this.getWebchat().campaign.show_agent && !this.message.self
          ? "https://" +
            this.getWebchat().configuration.ip +
            "/images/" +
            this.message.agent +
            ".jpg?" +
            Date.now()
          : this.getWebchat().campaign.logo
          ? this.getWebchat().campaign.logoName + "?" + new Date().getTime() + ")"
          : Avatar,
    };
  },

  computed: mapGetters([]),
  directives: {
    linkify,
  },
  created() {
    if (this.message) {
      if (this.menuMessage(this.message.message)) {
        this.$emit("menuMessage", this);
      }
      if (this.surveyMessage(this.message.message)) {
        this.$emit("surveyMessage", this);
      }
    }
  },
  methods: {
    disableMenuMessage(message) {
      if (this.$refs.menuMessage) {
        this.$refs.menuMessage.disableMenuMessage(message);
      }
    },
    invertColor,
    styleMessage,
    menuMessage(message) {
      return message
        .split(`\n`)
        .every(
          (text) =>
            text.match(/[0-9]+ *- *[^]*/imy) != null &&
            text.split(`-`.length == 2)
        );
    },
    getEnters(message) {
      let msgWithEnters = message.split(String.fromCharCode(10));
      return msgWithEnters;
    },
    surveyMessage(message) {
      if (message) {
        let m = message.split(`\n`);
        if (m[0] == "(faces)" || m[0] == "(yes/no)") {
          m.shift();
          return m.every((text) => text.match(/[0-9]+ *- *[^]*/imy) != null);
        }
        return false;
      }
    },
    getWebchat() {
      return this.$store.state[
        this.$store.state.findIndex(
          (e) => e.configuration.campaign === this.$route.query.campaign
        )
      ];
    },
    isFaces(message) {
      if (message) {
        let m = message.split(`\n`);
        return m[0] == "(faces)";
      }
      return false;
    },
    isYesNo(message) {
      if (message) {
        let m = message.split(`\n`);
        return m[0] == "(yes/no)";
      }
      return false;
    },
  },
};
</script>

<style scoped>
li {
  padding: 10px 0.5rem 0 0.5rem;
  overflow: hidden;
  display: flex;
}

.self {
  justify-content: flex-end;
  align-items: flex-end;
}

.other {
  justify-content: flex-start;
  align-items: flex-start;
}

.otherSurvey {
  justify-content: center !important;
  /* align-items: flex-start; */
}

.self .msg {
  background-color: #f8f8f8;
}

.other .msg {
  background-color: chocolate;
  box-shadow:0px 0px 2px rgba(0,0,0,0.4)
}

/* .otherSurvey .msg {
  background-color: chocolate;
} */

.containerMessage {
  max-width: 80%;
}

.containerMessage > p {
  color: #777;
  margin-top: 0px;
  margin-bottom: 0px;
  font-size: 12px;
}

.self > .containerMessage > p {
  margin-right: 7px;
  margin-top: 4px;
  text-align: right !important;
}

.other > .containerMessage > p {
  margin-right: 7px;
  margin-top: 4px;
  text-align: left !important;
}

::marker {
}
/* .otherSurvey > .containerMessage > p {
  margin-right: 7px;
  margin-top: 4px;
  text-align: left !important;
} */

.self .avatar {
  order: 2;
}

.msg {
  background: white;
  padding: 8px 15px;
  font-weight: 400;
  word-wrap: break-word;
  border-radius: 20px;
}

.msg p {
  font-size: 1rem;
  margin: 0 0 0.2rem 0;
  margin-bottom: 0px !important;
  color: #777;
}

.msg img {
  position: relative;
  display: block;
  width: 450px;
  border-radius: 6px;
  box-shadow: 0px 0px 3px #eee;
  transition: all 0.4s cubic-bezier(0.565, -0.26, 0.255, 1.41);
  cursor: default;
  -webkit-touch-callout: none;
  user-select: none;
}

.black-text {
  color: black !important;
}

@media screen and (max-width: 800px) {
  .msg img {
    width: 300px;
  }
}

@media screen and (max-width: 550px) {
  .msg img {
    width: 200px;
  }
}

.msg time {
  font-size: 0.7rem;
  color: #ccc;
  margin-top: 3px;
  float: right;
  cursor: default;
  user-select: none;
}

.line {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 6px;
  background-color: white;
  float: right;
  margin-right: 2px;
}

.padding-typing {
  padding: 14px 20px;
}

.load-3 .line:nth-last-child(1) {
  animation: loadingC 0.6s 0.1s linear infinite;
}

.load-3 .line:nth-last-child(2) {
  animation: loadingC 0.6s 0.2s linear infinite;
}

.load-3 .line:nth-last-child(3) {
  animation: loadingC 0.6s 0.3s linear infinite;
}

@keyframes loadingC {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 7px);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>
